import KatalLogger from '@amzn/katal-logger';
import { NodeEnv } from 'src/constants';

// In development the `https://gqyojlcpnb.execute-api.us-east-1.amazonaws.com/prod/v1/log` template never gets replaced with a
// real CloudFormation value, so any logger requests go to a 404. Omit `url`
// in dev so the logger writes to the browser console instead. See KatalLogger
// docs: when `url` is undefined, logs are sent to the console.
//
// logToConsole is OFF in all environments. In production the logs are shipped to
// the KatalLogger endpoint (CloudWatch), and in development they produced a wall
// of structured `Object` entries in the browser console that buried real errors
// and warnings. The info-level messages (linkUpdater, shadow-diff, account-fetch)
// are useful in CloudWatch but not in a developer's console. To re-enable for a
// debugging session, flip this to `true` or call `logger.setLogToConsole(true)`
// in the browser.
const isProduction = process.env.NODE_ENV === NodeEnv.production;

export const logger = new KatalLogger({
  url: isProduction ? 'https://gqyojlcpnb.execute-api.us-east-1.amazonaws.com/prod/v1/log' : undefined,
  maxLogLineSize: 10000, // default 5000
  logToConsole: false,
  context: {
    // The page each log line came from; without it a record carries only the
    // domain. A getter because KatalLogger keeps this object and spreads it
    // into every record, so it is read per line and follows client-side
    // navigation. The query string and hash are dropped: they can carry
    // entity and advertiser IDs.
    get pageUrl() {
      return `${window.location.origin}${window.location.pathname}`;
    },
  },
});
